// TODO we should probably consider moving checkout-sdk/src/utils/encryption functions to here and taking file out of "checkout" domain
import { ENCRYPTED_CARD_ERROR_CODE, SENSITIVE_MASK_CHAR } from '../constants';

/**
 * Checks if server-encrypted card had an error.
 */
export const encryptedCardHasError = (number: string) =>
  number.includes(ENCRYPTED_CARD_ERROR_CODE);

/**
 * Checks if frontend has masked a server-encrypted card number.
 */
export const isEncryptedCardMask = (number: string) =>
  number?.includes(SENSITIVE_MASK_CHAR);
